import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  displayErrorToast,
  displaySucessToast,
} from "@endya-conformite/ui-kit";
import { handleGatewayError } from "@src/data/utils/handleGatewayError";
import { controleQuinquennalKeys } from "@src/data/controle-quinquennal/hook/controle-quinquennal.keys";
import { FilesApi } from "../files.api";

export type AddFilePayload = {
  controleQuinquennalId: string;
  axeId: string;
  file: File;
  typePieceDeclare?: string;
};

export const useAddFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      controleQuinquennalId,
      axeId,
      file,
      typePieceDeclare,
    }: AddFilePayload) =>
      FilesApi.addFileToAxe(
        controleQuinquennalId,
        axeId,
        file,
        typePieceDeclare
      ),
    onSuccess: async (data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: controleQuinquennalKeys.axesWithFilesBase(
            variables.controleQuinquennalId,
            variables.axeId
          ),
        }),
        // Rafraîchit la fraîcheur du zip : la nouvelle pièce rend la version
        // téléchargée « non à jour » immédiatement, sans recharger la page.
        queryClient.invalidateQueries({
          queryKey: controleQuinquennalKeys.zipMetadata(
            variables.controleQuinquennalId,
            variables.axeId
          ),
        }),
      ]);

      displaySucessToast("La pièce a bien été ajoutée");
    },
    onError: (error) => {
      handleGatewayError({
        onUnhandled: (err) => {
          console.error(err);
          displayErrorToast(
            "Une erreur inconnue est survenue lors de l'ajout de la pièce"
          );
        },
      })(error);
    },
  });
};
